import React from 'react';

import { BaseDropdownOption, Dropdown } from '../../../../common/Dropdown';
import { individualViewTimePeriodOptions } from '../../constants';

export function IndividualViewDropdown({
  selectedTimePeriod,
  setSelectedTimePeriod,
  className,
}: {
  selectedTimePeriod: BaseDropdownOption;
  setSelectedTimePeriod: (timePeriod: BaseDropdownOption) => void;
  className?: string;
}): JSX.Element {
  return (
    <Dropdown<BaseDropdownOption>
      name="sprintId"
      label="Select Period"
      labelPosition="inline"
      className={className}
      options={individualViewTimePeriodOptions}
      value={selectedTimePeriod}
      onChange={(option) => {
        if (option) setSelectedTimePeriod(option);
      }}
    />
  );
}
